import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiAutocompleteInput, SuiSearchInput } from '@splashthat/sui';

import './styles.styl';

const noop = () => {};
const BASE_CLASS_NAME = 'PaginatedSearchDropdown';

export default class PaginatedSearchDropdown extends Component {
    static propTypes = {
        className: PropTypes.string,
        suggestionValues: PropTypes.array,
        onChange: PropTypes.func,
        onSearch: PropTypes.func,
        onScroll: PropTypes.func,
        placeholder: PropTypes.string,
        clearButton: PropTypes.bool,
        preventSuggestions: PropTypes.bool,
        overrideSuggestionFilter: PropTypes.bool,
        blurOnSelection: PropTypes.bool,
    };

    static defaultProps = {
        className: '',
        suggestionValues: [],
        onChange: noop,
        onSearch: noop,
        onScroll: noop,
        placeholder: null,
        clearButton: false,
        preventSuggestions: false,
        overrideSuggestionFilter: false,
        blurOnSelection: false,
    };

    handleSearch = (searchTerm) => {
        this.props.onSearch(searchTerm);
    };

    handlePaginationScroll = () => {
        this.props.onScroll();
    };

    handleChange = (event, suggestion, isCustom) => {
        this.props.onChange(event, suggestion, isCustom);
    };

    render() {
        const { className, placeholder, clearButton } = this.props;

        const inputElement = (
            <SuiSearchInput
                className={className}
                onSearch={this.handleSearch}
                placeholder={placeholder}
                icon={null}
                clearButton={clearButton}
            />
        );

        return (
            <SuiAutocompleteInput
                {...this.props}
                className={`${BASE_CLASS_NAME} ${className}`}
                onChange={this.handleChange}
                onScroll={this.handlePaginationScroll}
                menuClassName="PaginatedSearchDropdown"
                inputElement={inputElement}
            />
        );
    }
}
